<template>
  <ResourceView :entityId="$route.params.jobId" entityClass="Job" :defaultEmailTemplate="defaultEmailTemplate">
  </ResourceView>
</template>


<script>
import ResourceView from "@/views/admin/machines/ResourceView.vue";

export default {
  name: "ViewJobResources",
  components: {
    ResourceView,
  },

  data() {
    return {
    };
  },

  methods: {},

  computed: {
    defaultEmailTemplate() {
      return {
        CustomerId: this.CustomerId,
        To: this.CustomerPersonEmail,
        Subject: `#${this.orderId} `,
        Body: "",
        CC: null,
        Attachments: null,
      };
    },

    orderId() {
      return this.$store.getters["JobHub/JobDetails"]?.OrderId;
    },

    CustomerId() {
      return this.Customer && this.Customer.Id;
    },
    Customer() {
      return this.$store.getters["JobHub/Customer"];
    },

    CustomerPersonEmail() {
      var contact = this.$store.getters["JobHub/CustomerContact"];
      var email = contact && contact.Email ? contact.Email : undefined;
      return email;
    },
  },

  watch: {},
};
</script>


<style scoped></style>